import { Navigate, useParams } from 'react-router-dom'

import { DOCUMENT_QUERY_PARAM } from './documents-shared'

/** Legacy `/documents/:id` → list + canvas deep link. */
export function DocumentPage() {
  const { documentId } = useParams<{ documentId: string }>()
  if (!documentId) {
    return <Navigate to="/documents" replace />
  }
  return (
    <Navigate
      to={`/documents?${DOCUMENT_QUERY_PARAM}=${encodeURIComponent(documentId)}`}
      replace
    />
  )
}
